enum Visibility {
  PRIVATE = "private",
  SHARED_WITH_MANAGERS = "managers",
  SHARED_WITH_TEAM = "teams",
  SHARED_WITH_ORGANIZATION = "public",
}

export default Visibility;
